import {createRouter, createWebHashHistory} from "vue-router";
import PaHome from "../views/Pa-Home";
import PaVideos from "@/views/Pa-Videos";
import PaContact from "@/views/Pa-Contact";
import PaYoutube from "@/views/Pa-Youtube";
import PaStream from "@/views/Pa-Stream";
import PaEntertainment from "@/views/Pa-Entertainment.vue";

var router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes: [
        {path: '/', name: 'pa-home', component: PaHome},
        {path: '/videos', name: 'pa-videos', component: PaVideos},
        {path: '/contact', name: 'pa-contact', component: PaContact},
        {path: '/youtube', name: 'pa-youtube', component: PaYoutube},
        {path: '/stream', name: 'pa-stream', component: PaStream},
        {path: '/entertainment', name: 'pa-entertainment', component: PaEntertainment},
    ]
})

export default router
